import { useSyncExternalStore } from 'react';
import config from '../utils/config';
import { getLocalStorage, getUser } from '../utils/func';
import { isStorageKey } from '../utils/storage';

// A user can sign out/in, including as the same account, in another tab while
// a private screen or a device prompt is still open. Own async work by both
// the account and its token; profile edits alone must not restart that screen.
export const getSessionIdentity = () => JSON.stringify([
  getUser()?.id ?? null, getLocalStorage(config.token) || '',
]);

const subscribe = notify => {
  const storage = event => {
    if (isStorageKey(event, config.token) || isStorageKey(event, config.user)) notify();
  };
  window.addEventListener('wiw:session-changed', notify);
  window.addEventListener('storage', storage);
  return () => {
    window.removeEventListener('wiw:session-changed', notify);
    window.removeEventListener('storage', storage);
  };
};

export default function useSessionIdentity() {
  return useSyncExternalStore(subscribe, getSessionIdentity, getSessionIdentity);
}
